import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  current: number;
  total: number;
}
export function ProgressBar({
  current,
  total
}: ProgressBarProps) {
  const progress = Math.min(current / total * 100, 100);
  return <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-197">
      <motion.div className="h-full bg-indigo-500" initial={{
      width: 0
    }} animate={{
      width: `${progress}%`
    }} transition={{
      duration: 0.3
    }} data-id="element-198" />
    </div>;
}